export function GuestTags({ vip, rateCode }) {
  if (!vip && !rateCode) return null;
  return (
    <span className="inline-flex items-center gap-1 ml-1.5">
      {vip && (
        <span className="px-1 py-0 rounded-sm text-[8px] font-bold uppercase leading-tight bg-[#FFD60A]/20 text-[#FFD60A] border border-[#FFD60A]/40">{vip}</span>
      )}
      {!vip && rateCode && (
        <span className="px-1 py-0 rounded-sm text-[8px] font-bold uppercase leading-tight bg-[#BF5AF2]/20 text-[#BF5AF2] border border-[#BF5AF2]/40">{rateCode}</span>
      )}
    </span>
  );
}
